export default __webpack_public_path__ + "static/media/9.9212c4ec.png";